<template>
  <div class="box" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <!--一本打开-->
    <div class="card_wrap">
      <div class="card">
        <!-- <div class="input">
          <input-card
            :title="language('orderRecordByProducts.transaction')"
            :dataArr="inputShopArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div> -->
        <div class="ymd">
          <ymd-card-v2
            :title="language('productsRecord.period')"
            @change="changeTime"
            startTime="startTime"
            endTime="endTime"
            select="timeType"
            :options="timeOptios"
          ></ymd-card-v2>
        </div>
        <div class="input">
          <input-card
            :title="language('orderRecordByProducts.promotion')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div>
      </div>
      <div class="tips">{{ language("orderRecordByProducts.searchTips") }}</div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("orderRecordByProducts.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap">
      <div class="count_box">
        <div class="count">
          {{ language("orderRecord.results") }}: {{ results }}
          {{ language("orderRecord.rows") }}
          <template v-if="dataArr.length > 0">
            <el-button
              type="primary"
              @click="
                $utils.download2(
                  '/admin/merchant/report/exportProductRecord',
                  form4,
                  'code=product_record'
                )
              "
              >{{ language("all.download") }}</el-button
            >
          </template>
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>

      <cc-table
        :loadData="false"
        :dataArr="dataArr"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :emptyText="language('orderRecordByProducts.emptyText')"
        :showIndex="false"
      ></cc-table>

      <div class="tips_text">
        <h4>Records will be updated in daily basis before 6 am</h4>
        <h4>
          "On Hold" Orders are the incomplete orders(e.g. Confirmed, Picked,
          DeliveredTM)
        </h4>
        <h4>
          "Delivered" Orders are the orders which already received by warehouse
        </h4>
        <h4>"CSCancel" are the orders which already cancelled by CS</h4>
        <h4>
          "Cancel" are the orders which already confirmed to cancel from both CS
          and merchant
        </h4>
        <!-- <h4>
          "CSCancel" are the orders which already confirmed to cancel from both
          CS and merchant
        </h4> -->
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import inputCard from "../../components/inputCard";
import ymdCardV2 from "../../components/ymdCardV2";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    inputCard,
    ymdCardV2,
    page,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("orderRecordByProducts.breadcrumbTitle"),
        list: [
          {
            name: this.language("orderRecordByProducts.breadcrumbList_1"),
          },
          {
            name: this.language("orderRecordByProducts.breadcrumbList_2"),
          },
        ],
      },
      inputShopArr: [
        {
          name: "Merhant ID",
          apiName: "Merhant ID",
          value: "",
          type: "select",
          options: [],
        },
      ],
      inputArr: [
        {
          name: "Promotion ID",
          apiName: "promotionId",
          value: "",
        },
      ],
      timeOptios: [
        { label: "Order Last Updated", value: "updateTime" },
        { label: "Order Create Date", value: "createDate" },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "orderTime",
            lable: "Order Create Date",
            minWidth: 200,
          },
          {
            prop: "updateTime",
            lable: "Order Last Updated",
            minWidth: 200,
          },
          {
            prop: "productId",
            lable: "Product ID",
            minWidth: 170,
          },
          {
            prop: "productName",
            lable: "Product Name",
            minWidth: 120,
          },
          {
            prop: "promotionId",
            lable: "Promotion Id",
            minWidth: 230,
          },
          {
            prop: "promotionName",
            lable: "Promotion Name",
            minWidth: 230,
          },
          {
            prop: "originalPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.originalPrice, 2);
            },
          },
          {
            prop: "Quantity",
            lable: "Quantity",
            columns: [
              {
                prop: "onHold",
                lable: "OnHold",
              },
              {
                prop: "delivered",
                lable: "Delivered",
              },
              {
                prop: "cancel",
                lable: "Cancel",
              },
              {
                prop: "csCancel",
                lable: "CSCancel",
              },
              {
                prop: "refund",
                lable: "ReFunded",
              },
            ],
          },
        ],
        buttons: [],
      },
      dataArr: [],
      results: 0,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      form1: {},
      form2: {},
      form3: {},
      form4:{}
    };
  },
  methods: {
    changeShop(e) {
      console.log(e);
    },
    changeInput(e) {
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeTime(e) {
      if (e.timeType == "updateTime") {
        this.form2 = {
          geUpdateTime: e.startTime,
          leUpdateTime: e.endTime,
        };
      } else {
        this.form2 = {
          geOrderTime: e.startTime,
          leOrderTime: e.endTime,
        };
      }
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    svaeForm(form1, form2, form3) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        pageSize: this.form.pageSize,
        pageNo: this.form.pageNo,
            shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;

      this.getData(this.form);
    },
    search() {
      console.log(this.form);
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.$refs.page.init();
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      // this.form.shopNum = this.shopData.shopNum;
      // this.form.mchShopNum = this.shopData.shopNum;
      this.form4=e
      this.ccRequest
        .do("admin/merchant/report/getProductRecord?code=product_record", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    let shopData = this.$shopData;
    this.shopData = shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    .status {
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
      margin-right: 20px;
    }
    .ymd {
      flex: 1;
      margin-right: 20px;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}

.button_wrap {
  margin-bottom: 20px;
}
.table_wrap {
  margin-top: 20px;
  .count {
    font-size: $sbuTitle;
    font-weight: 600;
  }
  .count_box {
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.count_data {
  margin: 20px 0;
  .clearfix {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      justify-content: space-between;
      h3 {
        margin-right: 40px;
      }
    }
  }
}
.count_table {
  margin: 20px 0;
}
.tips_text {
  padding: 40px 0;
  h4 {
    margin-bottom: 15px;
  }
}
.download {
  margin-bottom: 20px;
}
</style>
